export default __webpack_public_path__ + "static/media/Product3.d823d53e.PNG";